<template>
  <div>
    <v-card class="text-xs-center mt-4" hover>
      <div style="position: absolute; right: 3px; top: 3px">
        <v-btn flat icon color="grey" @click="edit = true" v-if="userAuthClass">
          <v-icon>edit</v-icon>
        </v-btn>
      </div>

      <div class>
        <v-avatar :color="color" size="66" class="overlap-avatar">
          <span class="white--text headline">{{letter.toUpperCase()}}</span>
        </v-avatar>
      </div>

      <v-card-text @click="detailDialog = true">
        <div class="pb-3">
          <h5 class="subheading font-weight-regular text-capitalize">{{spoil.name}}</h5>
        </div>
        <div class="pb-4">
          <h5 class="subheading font-weight-regular grey--text text--darken-1">{{spoil.type}}</h5>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat icon color="red lighten-3" @click="deleteDialog = true" v-if="userAuthClass">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-card-actions>
      <slot name="parentActions"></slot>
      <div class="card-divider grey lighten-2" style="margin-top: 0px;"></div>

      <div class="card-footer text-xs-left">
        <time-ago class="grey--text" :subject="spoil" :time="spoil.updatedAt" needsParse updated>
          <v-icon small color="grey"  slot="icon" class="mr-2">access_time</v-icon>
        </time-ago>
      </div>
      <div style="width: 100%; height: 2px;" :class="color"></div>
    </v-card>

    <!--EDIT DIALOG -->
    <v-dialog
      v-model="edit"
      max-width="700px"
      @keydown.esc="edit = false"
      lazy
      v-if="userAuthClass"
    >
      <edit-spoil :spoil="spoil" @close="edit = false" @spoilEdited="displaySnack"></edit-spoil>
    </v-dialog>

    <!-- DETAIL DIALOG -->
    <v-dialog v-model="detailDialog" fullscreen hide-overlay transition="scale-transition" lazy>
      <spoil-detail @close="detailDialog = false" :spoil="spoil" :color="color"></spoil-detail>
    </v-dialog>

    <!-- DELETE CONFIRMATION DIALOG -->
    <v-dialog
      v-model="deleteDialog"
      max-width="400px"
      @keydown.esc="deleteDialog = false"
      lazy
      v-if="userAuthClass"
    >
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{spoil.name}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteSpoil(); deleteDialog = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import SpoilService from "@/services/requests/spoilService";
import getColorFromChar from "@/services/helpers/getColorFromChar";
import EditSpoil from "@/components/spoils/editSpoil";
import DisplaySnack from "@/services/mixins/displaySnack";
import SpoilDetail from "@/components/spoils/spoilDetail";
export default {
  components: {
    SpoilDetail,
    EditSpoil
  },
  mixins: [DisplaySnack],
  data() {
    return {
      edit: false,
      deleteDialog: false,
      detailDialog: false
    };
  },
  methods: {
    deleteSpoil() {
      var spoil = this.spoil;
      SpoilService.deleteSpoil(spoil.id)
        .then(result => {
          //console.log(result.data);
          this.$store.commit("spoils/deleteFromArrayStateByValue", {
            prop: "spoils",
            value: spoil
          });
          this.snack({ text: "Spoil was deleted!", color: "yellow" });
        })
        .catch(err => {
          //console.log("An error occured");
          this.snackError();
        });
    }
  },
  props: {
    spoil: Object,
    index: Number
  },
  computed: {
    color() {
      return getColorFromChar(this.spoil.name.charCodeAt(0));
    },
    letter() {
      return this.spoil.name.charAt(0);
    }
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.overlap-avatar {
  margin-top: -35px;
  border: 6px solid #eee;
  border-color: #eee !important;
}
</style>
